module.exports = __webpack_public_path__ + "static/media/103.86fc8e38.png";